import type { FormImageInput } from "../core/data-forms/form-input-types";
import { isDefined } from "./assert";

export function hasMultiplePages(imageInput: FormImageInput) {
  return (
    isDefined(imageInput.minimumPageCount) &&
    (imageInput.minimumPageCount !== imageInput.maximumPageCount || imageInput.minimumPageCount > 1)
  );
}
